// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"479":"6ad7a9fa","888":"0409267a"}[chunkId] + ".chunk.css";
};